import { render, staticRenderFns } from "./loanmonthlyreport.vue?vue&type=template&id=2c3b033e"
import script from "./loanmonthlyreport.vue?vue&type=script&lang=js"
export * from "./loanmonthlyreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports